// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Contact.css  —  KinetiQ Contact page
   Colour system aligned with KineticLandingPage.css:
     navy #1A3C6E · teal #0B8DA6 · accent #00C2A8 · dark #0D1F35
     warm light #faf6f0 · border #D6E4EC · grey #6B7A8D
   Hero uses the landing page's navy gradient with a teal glow,
   the form card is white with the landing card shadow, and the
   primary button matches the landing .btn-primary.
   ============================================================ */

/* ── Scoped tokens (same values as the landing page :root) ───── */
.ct-page {
  --ct-blue:        #1A3C6E;   /* --kinetic-blue   */
  --ct-blue-mid:    #0E2A52;
  --ct-teal:        #0B8DA6;   /* --kinetic-teal   */
  --ct-accent:      #00C2A8;   /* --kinetic-accent */
  --ct-accent-hover:#00a896;
  --ct-dark:        #0D1F35;   /* --kinetic-dark   */
  --ct-gray:        #6B7A8D;   /* --kinetic-gray   */
  --ct-border:      #D6E4EC;   /* --kinetic-border */
  --ct-bg:          #faf6f0;   /* --kinetic-light  */
  --ct-surface:     #ffffff;

  --ct-accent-dim:  rgba(0, 194, 168, 0.12);
  --ct-accent-line: rgba(0, 194, 168, 0.35);
  --ct-teal-dim:    rgba(11, 141, 166, 0.10);
  --ct-teal-line:   rgba(11, 141, 166, 0.28);

  --ct-error:       #e03535;

  --ct-radius-sm:   6px;
  --ct-radius:      12px;
  --ct-radius-lg:   20px;
  --ct-shadow-card: 0 4px 24px rgba(10, 50, 90, 0.10);

  --ct-font:        'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;
  --ct-transition:  0.2s ease;

  min-height: 100%;
  background: var(--ct-bg);
  font-family: var(--ct-font);
  color: var(--ct-dark);
  font-size: 16px;
  line-height: 1.65;
  padding-bottom: 48px;
  -webkit-font-smoothing: antialiased;
}

.ct-page ::-webkit-scrollbar       { width: 5px; height: 5px; }
.ct-page ::-webkit-scrollbar-track { background: transparent; }
.ct-page ::-webkit-scrollbar-thumb { background: var(--ct-border); border-radius: 3px; }

/* ─────────────────────────────────────────────────────────────
   Hero — landing page navy gradient + teal glow
───────────────────────────────────────────────────────────── */
.ct-hero {
  position: relative;
  padding: 56px 48px 48px;
  overflow: hidden;
  color: #ffffff;
  background: linear-gradient(160deg, var(--ct-blue) 0%, var(--ct-blue-mid) 55%, var(--ct-dark) 100%);
}

.ct-hero-glow {
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0, 194, 168, 0.16) 0%, transparent 70%);
  pointer-events: none;
}

.ct-hero-inner {
  position: relative;
  max-width: 680px;
}

.ct-hero-chip {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ct-accent);
  background: var(--ct-accent-dim);
  border: 1px solid var(--ct-accent-line);
  border-radius: 999px;
  padding: 5px 14px;
  margin-bottom: 16px;
}

.ct-hero-title {
  font-size: clamp(1.9rem, 3.2vw, 2.5rem);
  font-weight: 800;
  letter-spacing: -0.5px;
  color: #ffffff;
  line-height: 1.2;
  margin: 0 0 12px;
}

.ct-hero-accent { color: var(--ct-accent); }

.ct-hero-sub {
  font-size: 1.02rem;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.72);
  line-height: 1.75;
  margin: 0 0 22px;
  max-width: 540px;
}

.ct-hero-email {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  font-size: 0.97rem;
  font-weight: 700;
  color: var(--ct-accent);
  background: rgba(255, 255, 255, 0.07);
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: var(--ct-radius-sm);
  padding: 10px 18px;
  text-decoration: none;
  transition: background var(--ct-transition), border-color var(--ct-transition), transform var(--ct-transition);
}

.ct-hero-email svg { flex-shrink: 0; }

.ct-hero-email:hover {
  background: rgba(0, 194, 168, 0.14);
  border-color: var(--ct-accent);
  transform: translateY(-1px);
}

/* ─────────────────────────────────────────────────────────────
   Body
───────────────────────────────────────────────────────────── */
.ct-body {
  padding: 36px 48px 0;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.ct-main-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 28px;
  align-items: start;
}

/* Section head */
.ct-section-head { margin-bottom: 22px; }

.ct-section-chip {
  display: inline-block;
  font-size: 0.75rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--ct-teal);
  margin-bottom: 10px;
}

.ct-section-title {
  font-size: clamp(1.4rem, 2.4vw, 1.75rem);
  font-weight: 700;
  letter-spacing: -0.3px;
  color: var(--ct-blue);
  margin: 0 0 8px;
  line-height: 1.2;
}

.ct-section-desc {
  font-size: 1rem;
  font-weight: 400;
  color: var(--ct-gray);
  line-height: 1.7;
  margin: 0;
}

/* ─────────────────────────────────────────────────────────────
   Form card
───────────────────────────────────────────────────────────── */
.ct-form-section {
  position: relative;
  background: var(--ct-surface);
  border: 1px solid var(--ct-border);
  border-top: 3px solid var(--ct-accent);
  border-radius: var(--ct-radius);
  padding: 32px 32px 36px;
  box-shadow: var(--ct-shadow-card);
  animation: ctFadeIn 0.25s ease;
}

.ct-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.ct-form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.ct-field {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.ct-label {
  font-size: 0.82rem;
  font-weight: 600;
  color: var(--ct-blue);
  letter-spacing: 0.02em;
}

.ct-label-optional {
  font-weight: 400;
  color: var(--ct-gray);
}

.ct-input,
.ct-textarea {
  width: 100%;
  box-sizing: border-box;
  background: #f7fafc;
  border: 1px solid var(--ct-border);
  border-radius: var(--ct-radius-sm);
  padding: 11px 14px;
  font-family: var(--ct-font);
  font-size: 0.92rem;
  font-weight: 400;
  line-height: 1.55;
  color: var(--ct-dark);
  outline: none;
  transition: border-color var(--ct-transition), background var(--ct-transition), box-shadow var(--ct-transition);
}

.ct-input::placeholder,
.ct-textarea::placeholder { color: #9aa8b8; }

.ct-input:focus,
.ct-textarea:focus {
  background: #ffffff;
  border-color: var(--ct-accent);
  box-shadow: 0 0 0 3px rgba(0, 194, 168, 0.16);
}

.ct-textarea {
  resize: vertical;
  min-height: 130px;
}

.ct-field--error .ct-input,
.ct-field--error .ct-textarea {
  border-color: rgba(224, 53, 53, 0.6);
  box-shadow: 0 0 0 3px rgba(224, 53, 53, 0.08);
}

.ct-error-msg {
  font-size: 0.78rem;
  color: var(--ct-error);
}

/* Submit — landing .btn-primary */
.ct-submit-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  align-self: flex-start;
  min-width: 170px;
  background: var(--ct-accent);
  color: var(--ct-dark);
  font-family: var(--ct-font);
  font-size: 0.95rem;
  font-weight: 700;
  border: none;
  border-radius: var(--ct-radius-sm);
  padding: 13px 28px;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 194, 168, 0.35);
  transition: background var(--ct-transition), transform 0.15s, box-shadow var(--ct-transition);
}

.ct-submit-btn:hover:not(:disabled) {
  background: var(--ct-accent-hover);
  transform: translateY(-2px);
  box-shadow: 0 6px 24px rgba(0, 194, 168, 0.45);
}

.ct-submit-btn:active:not(:disabled) { transform: scale(0.98); }

.ct-submit-btn:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.ct-spinner {
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid rgba(13, 31, 53, 0.25);
  border-top-color: var(--ct-dark);
  border-radius: 50%;
  animation: ctSpin 0.7s linear infinite;
}

@keyframes ctSpin { to { transform: rotate(360deg); } }

/* Success state */
.ct-success {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 32px 24px;
  gap: 12px;
}

.ct-success-icon {
  color: var(--ct-accent);
  animation: ctPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes ctPop {
  from { transform: scale(0.5); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}

.ct-success-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--ct-blue);
  line-height: 1.2;
  margin: 0;
}

.ct-success-msg {
  font-size: 0.92rem;
  color: var(--ct-gray);
  line-height: 1.65;
  margin: 0;
  max-width: 360px;
}

.ct-success-msg strong { color: var(--ct-blue); }

.ct-success-btn {
  margin-top: 6px;
  padding: 10px 24px;
  background: var(--ct-teal-dim);
  border: 1px solid var(--ct-teal-line);
  border-radius: var(--ct-radius-sm);
  color: var(--ct-teal);
  font-family: var(--ct-font);
  font-size: 0.92rem;
  font-weight: 700;
  cursor: pointer;
  transition: background var(--ct-transition), border-color var(--ct-transition);
}

.ct-success-btn:hover {
  background: rgba(11, 141, 166, 0.18);
  border-color: var(--ct-teal);
}

/* ─────────────────────────────────────────────────────────────
   Animation
───────────────────────────────────────────────────────────── */
@keyframes ctFadeIn {
  from { opacity: 0; transform: translateY(4px); }
  to   { opacity: 1; transform: translateY(0);   }
}

/* ─────────────────────────────────────────────────────────────
   Responsive
───────────────────────────────────────────────────────────── */
@media (max-width: 700px) {
  .ct-hero { padding: 32px 20px 28px; }
  .ct-body { padding: 24px 20px 0; }
  .ct-form-section { padding: 22px 18px 26px; }
  .ct-form-row { grid-template-columns: 1fr; }
  .ct-submit-btn { width: 100%; align-self: stretch; }
}`, "",{"version":3,"sources":["webpack://./src/styles/Contact.css"],"names":[],"mappings":"AAAA;;;;;;;;iEAQiE;;AAIjE,mEAAmE;AACnE;EACE,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB;EACzB,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB;EACzB,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB,IAAI,qBAAqB;EAClD,yBAAyB;;EAEzB,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;;EAE1C,yBAAyB;;EAEzB,qBAAqB;EACrB,sBAAsB;EACtB,sBAAsB;EACtB,mDAAmD;;EAEnD,oFAAoF;EACpF,2BAA2B;;EAE3B,gBAAgB;EAChB,wBAAwB;EACxB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mCAAmC;AACrC;;AAEA,qCAAqC,UAAU,EAAE,WAAW,EAAE;AAC9D,qCAAqC,uBAAuB,EAAE;AAC9D,qCAAqC,4BAA4B,EAAE,kBAAkB,EAAE;;AAEvF;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,mGAAmG;AACrG;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,oGAAoG;EACpG,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,gCAAgC;EAChC,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kBAAkB,uBAAuB,EAAE;;AAE3C;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,2CAA2C;EAC3C,kCAAkC;EAClC,kBAAkB;EAClB,qBAAqB;EACrB,8GAA8G;AAChH;;AAEA,qBAAqB,cAAc,EAAE;;AAErC;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;;+DAE+D;AAC/D;EACE,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB,mBAAmB,mBAAmB,EAAE;;AAExC;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;;+DAE+D;AAC/D;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;EAClC,sCAAsC;EACtC,+BAA+B;EAC/B,uBAAuB;EACvB,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,kCAAkC;EAClC,kCAAkC;EAClC,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,+GAA+G;AACjH;;AAEA;4BAC4B,cAAc,EAAE;;AAE5C;;EAEE,mBAAmB;EACnB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,oCAAoC;EACpC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sBAAsB;EACtB,gBAAgB;EAChB,4BAA4B;EAC5B,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,6FAA6F;AAC/F;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA,uCAAuC,sBAAsB,EAAE;;AAE/D;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,gCAAgC;EAChC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA,oBAAoB,KAAK,yBAAyB,EAAE,EAAE;;AAEtD,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,uDAAuD;AACzD;;AAEA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,IAAI,UAAU,EAAE;AAC5C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA,yBAAyB,qBAAqB,EAAE;;AAEhD;EACE,eAAe;EACf,kBAAkB;EAClB,8BAA8B;EAC9B,qCAAqC;EACrC,kCAAkC;EAClC,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;;+DAE+D;AAC/D;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,IAAI;AACjD;;AAEA;;+DAE+D;AAC/D;EACE,WAAW,uBAAuB,EAAE;EACpC,WAAW,oBAAoB,EAAE;EACjC,mBAAmB,uBAAuB,EAAE;EAC5C,eAAe,0BAA0B,EAAE;EAC3C,iBAAiB,WAAW,EAAE,mBAAmB,EAAE;AACrD","sourcesContent":["/* ============================================================\n   Contact.css  —  KinetiQ Contact page\n   Colour system aligned with KineticLandingPage.css:\n     navy #1A3C6E · teal #0B8DA6 · accent #00C2A8 · dark #0D1F35\n     warm light #faf6f0 · border #D6E4EC · grey #6B7A8D\n   Hero uses the landing page's navy gradient with a teal glow,\n   the form card is white with the landing card shadow, and the\n   primary button matches the landing .btn-primary.\n   ============================================================ */\n\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap');\n\n/* ── Scoped tokens (same values as the landing page :root) ───── */\n.ct-page {\n  --ct-blue:        #1A3C6E;   /* --kinetic-blue   */\n  --ct-blue-mid:    #0E2A52;\n  --ct-teal:        #0B8DA6;   /* --kinetic-teal   */\n  --ct-accent:      #00C2A8;   /* --kinetic-accent */\n  --ct-accent-hover:#00a896;\n  --ct-dark:        #0D1F35;   /* --kinetic-dark   */\n  --ct-gray:        #6B7A8D;   /* --kinetic-gray   */\n  --ct-border:      #D6E4EC;   /* --kinetic-border */\n  --ct-bg:          #faf6f0;   /* --kinetic-light  */\n  --ct-surface:     #ffffff;\n\n  --ct-accent-dim:  rgba(0, 194, 168, 0.12);\n  --ct-accent-line: rgba(0, 194, 168, 0.35);\n  --ct-teal-dim:    rgba(11, 141, 166, 0.10);\n  --ct-teal-line:   rgba(11, 141, 166, 0.28);\n\n  --ct-error:       #e03535;\n\n  --ct-radius-sm:   6px;\n  --ct-radius:      12px;\n  --ct-radius-lg:   20px;\n  --ct-shadow-card: 0 4px 24px rgba(10, 50, 90, 0.10);\n\n  --ct-font:        'Inter', 'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif;\n  --ct-transition:  0.2s ease;\n\n  min-height: 100%;\n  background: var(--ct-bg);\n  font-family: var(--ct-font);\n  color: var(--ct-dark);\n  font-size: 16px;\n  line-height: 1.65;\n  padding-bottom: 48px;\n  -webkit-font-smoothing: antialiased;\n}\n\n.ct-page ::-webkit-scrollbar       { width: 5px; height: 5px; }\n.ct-page ::-webkit-scrollbar-track { background: transparent; }\n.ct-page ::-webkit-scrollbar-thumb { background: var(--ct-border); border-radius: 3px; }\n\n/* ─────────────────────────────────────────────────────────────\n   Hero — landing page navy gradient + teal glow\n───────────────────────────────────────────────────────────── */\n.ct-hero {\n  position: relative;\n  padding: 56px 48px 48px;\n  overflow: hidden;\n  color: #ffffff;\n  background: linear-gradient(160deg, var(--ct-blue) 0%, var(--ct-blue-mid) 55%, var(--ct-dark) 100%);\n}\n\n.ct-hero-glow {\n  position: absolute;\n  inset: 0;\n  background: radial-gradient(ellipse 70% 60% at 75% 40%, rgba(0, 194, 168, 0.16) 0%, transparent 70%);\n  pointer-events: none;\n}\n\n.ct-hero-inner {\n  position: relative;\n  max-width: 680px;\n}\n\n.ct-hero-chip {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ct-accent);\n  background: var(--ct-accent-dim);\n  border: 1px solid var(--ct-accent-line);\n  border-radius: 999px;\n  padding: 5px 14px;\n  margin-bottom: 16px;\n}\n\n.ct-hero-title {\n  font-size: clamp(1.9rem, 3.2vw, 2.5rem);\n  font-weight: 800;\n  letter-spacing: -0.5px;\n  color: #ffffff;\n  line-height: 1.2;\n  margin: 0 0 12px;\n}\n\n.ct-hero-accent { color: var(--ct-accent); }\n\n.ct-hero-sub {\n  font-size: 1.02rem;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.72);\n  line-height: 1.75;\n  margin: 0 0 22px;\n  max-width: 540px;\n}\n\n.ct-hero-email {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  font-size: 0.97rem;\n  font-weight: 700;\n  color: var(--ct-accent);\n  background: rgba(255, 255, 255, 0.07);\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: var(--ct-radius-sm);\n  padding: 10px 18px;\n  text-decoration: none;\n  transition: background var(--ct-transition), border-color var(--ct-transition), transform var(--ct-transition);\n}\n\n.ct-hero-email svg { flex-shrink: 0; }\n\n.ct-hero-email:hover {\n  background: rgba(0, 194, 168, 0.14);\n  border-color: var(--ct-accent);\n  transform: translateY(-1px);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Body\n───────────────────────────────────────────────────────────── */\n.ct-body {\n  padding: 36px 48px 0;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.ct-main-grid {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr);\n  gap: 28px;\n  align-items: start;\n}\n\n/* Section head */\n.ct-section-head { margin-bottom: 22px; }\n\n.ct-section-chip {\n  display: inline-block;\n  font-size: 0.75rem;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--ct-teal);\n  margin-bottom: 10px;\n}\n\n.ct-section-title {\n  font-size: clamp(1.4rem, 2.4vw, 1.75rem);\n  font-weight: 700;\n  letter-spacing: -0.3px;\n  color: var(--ct-blue);\n  margin: 0 0 8px;\n  line-height: 1.2;\n}\n\n.ct-section-desc {\n  font-size: 1rem;\n  font-weight: 400;\n  color: var(--ct-gray);\n  line-height: 1.7;\n  margin: 0;\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Form card\n───────────────────────────────────────────────────────────── */\n.ct-form-section {\n  position: relative;\n  background: var(--ct-surface);\n  border: 1px solid var(--ct-border);\n  border-top: 3px solid var(--ct-accent);\n  border-radius: var(--ct-radius);\n  padding: 32px 32px 36px;\n  box-shadow: var(--ct-shadow-card);\n  animation: ctFadeIn 0.25s ease;\n}\n\n.ct-form {\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.ct-form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 16px;\n}\n\n.ct-field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.ct-label {\n  font-size: 0.82rem;\n  font-weight: 600;\n  color: var(--ct-blue);\n  letter-spacing: 0.02em;\n}\n\n.ct-label-optional {\n  font-weight: 400;\n  color: var(--ct-gray);\n}\n\n.ct-input,\n.ct-textarea {\n  width: 100%;\n  box-sizing: border-box;\n  background: #f7fafc;\n  border: 1px solid var(--ct-border);\n  border-radius: var(--ct-radius-sm);\n  padding: 11px 14px;\n  font-family: var(--ct-font);\n  font-size: 0.92rem;\n  font-weight: 400;\n  line-height: 1.55;\n  color: var(--ct-dark);\n  outline: none;\n  transition: border-color var(--ct-transition), background var(--ct-transition), box-shadow var(--ct-transition);\n}\n\n.ct-input::placeholder,\n.ct-textarea::placeholder { color: #9aa8b8; }\n\n.ct-input:focus,\n.ct-textarea:focus {\n  background: #ffffff;\n  border-color: var(--ct-accent);\n  box-shadow: 0 0 0 3px rgba(0, 194, 168, 0.16);\n}\n\n.ct-textarea {\n  resize: vertical;\n  min-height: 130px;\n}\n\n.ct-field--error .ct-input,\n.ct-field--error .ct-textarea {\n  border-color: rgba(224, 53, 53, 0.6);\n  box-shadow: 0 0 0 3px rgba(224, 53, 53, 0.08);\n}\n\n.ct-error-msg {\n  font-size: 0.78rem;\n  color: var(--ct-error);\n}\n\n/* Submit — landing .btn-primary */\n.ct-submit-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  align-self: flex-start;\n  min-width: 170px;\n  background: var(--ct-accent);\n  color: var(--ct-dark);\n  font-family: var(--ct-font);\n  font-size: 0.95rem;\n  font-weight: 700;\n  border: none;\n  border-radius: var(--ct-radius-sm);\n  padding: 13px 28px;\n  cursor: pointer;\n  box-shadow: 0 4px 16px rgba(0, 194, 168, 0.35);\n  transition: background var(--ct-transition), transform 0.15s, box-shadow var(--ct-transition);\n}\n\n.ct-submit-btn:hover:not(:disabled) {\n  background: var(--ct-accent-hover);\n  transform: translateY(-2px);\n  box-shadow: 0 6px 24px rgba(0, 194, 168, 0.45);\n}\n\n.ct-submit-btn:active:not(:disabled) { transform: scale(0.98); }\n\n.ct-submit-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.65;\n}\n\n.ct-spinner {\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(13, 31, 53, 0.25);\n  border-top-color: var(--ct-dark);\n  border-radius: 50%;\n  animation: ctSpin 0.7s linear infinite;\n}\n\n@keyframes ctSpin { to { transform: rotate(360deg); } }\n\n/* Success state */\n.ct-success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 32px 24px;\n  gap: 12px;\n}\n\n.ct-success-icon {\n  color: var(--ct-accent);\n  animation: ctPop 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes ctPop {\n  from { transform: scale(0.5); opacity: 0; }\n  to   { transform: scale(1);   opacity: 1; }\n}\n\n.ct-success-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--ct-blue);\n  line-height: 1.2;\n  margin: 0;\n}\n\n.ct-success-msg {\n  font-size: 0.92rem;\n  color: var(--ct-gray);\n  line-height: 1.65;\n  margin: 0;\n  max-width: 360px;\n}\n\n.ct-success-msg strong { color: var(--ct-blue); }\n\n.ct-success-btn {\n  margin-top: 6px;\n  padding: 10px 24px;\n  background: var(--ct-teal-dim);\n  border: 1px solid var(--ct-teal-line);\n  border-radius: var(--ct-radius-sm);\n  color: var(--ct-teal);\n  font-family: var(--ct-font);\n  font-size: 0.92rem;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background var(--ct-transition), border-color var(--ct-transition);\n}\n\n.ct-success-btn:hover {\n  background: rgba(11, 141, 166, 0.18);\n  border-color: var(--ct-teal);\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Animation\n───────────────────────────────────────────────────────────── */\n@keyframes ctFadeIn {\n  from { opacity: 0; transform: translateY(4px); }\n  to   { opacity: 1; transform: translateY(0);   }\n}\n\n/* ─────────────────────────────────────────────────────────────\n   Responsive\n───────────────────────────────────────────────────────────── */\n@media (max-width: 700px) {\n  .ct-hero { padding: 32px 20px 28px; }\n  .ct-body { padding: 24px 20px 0; }\n  .ct-form-section { padding: 22px 18px 26px; }\n  .ct-form-row { grid-template-columns: 1fr; }\n  .ct-submit-btn { width: 100%; align-self: stretch; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
